import { render } from "./notAuthorized.vue?vue&type=template&id=74b6ee8e&scoped=true"
import script from "./notAuthorized.vue?vue&type=script&lang=js"
export * from "./notAuthorized.vue?vue&type=script&lang=js"

import "./notAuthorized.vue?vue&type=style&index=0&id=74b6ee8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b6ee8e"]])

export default __exports__